import {Component, Input} from '@angular/core';
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-sucursales-especialidades',
  standalone: true,
  imports: [
    NgIf,
    NgForOf,
    NgOptimizedImage
  ],
  templateUrl: './sucursales-especialidades.component.html',
  styleUrl: './sucursales-especialidades.component.css'
})
export class SucursalesEspecialidadesComponent {

  @Input() sucursales: any[] = [];

}
